const TheContainer = () => import("@/containers/TheContainer.vue")
const AdminCertificationList = () => import('./AdminCertificationList.vue')
const AdminCertificationDetail = () => import('./AdminCertificationDetail.vue')

export default [
    {
        path: '/admin/certifications',
        component: TheContainer,
        meta: { perms: ['admin.certifications.list'] },
        redirect: { name: 'adminCertificationList' },
        children: [
            {
                path: '',
                name: 'adminCertificationList',
                component: AdminCertificationList,
                meta: { label: 'Certifications' }
            },
            {
                path: ':id',
                name: 'adminCertificationDetail',
                component: AdminCertificationDetail,
                meta: { label: 'Certification Detail' }
            }
        ]
    }
]
